import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";

const SpeakerRow = ({ id, name, image, title, onDelete, description }) => {
  const { API } = useStateContext();

  const handleDeleteSpeaker = () => {
    const confirmed = window.confirm("Are you sure you want to delete this speaker?");
    if (confirmed) {
      onDelete(id);
    }
  };

  return (
    <tr>
      <td className="ps-4 fw-semibold">{name}</td>
      <td>{title || "—"}</td>
      <td className="text-muted" style={{ maxWidth: 280 }}>
        {description || "No description available"}
      </td>
      <td>
        <img src={`${API}${image}`} alt={name} className="rounded-3" style={{ width: 56, height: 56, objectFit: "cover" }} />
      </td>
      <td className="pe-4">
        <div className="d-flex flex-wrap gap-2">
          <Link className="btn btn-sm btn-dark" to={`./edit/${id}`}>
            Edit
          </Link>
          <button className="btn btn-sm btn-outline-danger" onClick={handleDeleteSpeaker}>
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
};

export default SpeakerRow;
